import enData from '../data/products/en.json';
import zhData from '../data/products/zh.json';

const dataMap = { en: enData, zh: zhData };

const getData = (language = 'en') => dataMap[language] || dataMap.en;

export const getCategoryLabel = (key, language = 'en') => {
  const data = getData(language);
  const meta = data.categories?.[key];
  return meta?.label || key;
};

export const getCategorySlug = (key, language = 'en') => {
  const data = getData(language);
  const meta = data.categories?.[key];
  return meta?.slug || key;
};

export const getCategoryMeta = (key, language = 'en') => {
  const data = getData(language);
  return data.categories?.[key] || null;
};

export const getAllCategoryKeys = (language = 'en') => {
  const data = getData(language);
  return Object.keys(data.categories || {});
};

export const getCategoryBySlug = (slug, language = 'en') => {
  const data = getData(language);
  const categories = data.categories || {};
  for (const [key, meta] of Object.entries(categories)) {
    if ((meta.slug || key) === slug) return { key, ...meta };
  }
  return null;
};

const defaultIcons = {
  'business-solutions': '🏢',
  'embedded-systems': '⚙️',
  'localized-ai': '🤖',
  'custom-solutions': '🛠️'
};

export const getEnabledCategories = (language = 'en') => {
  const data = getData(language);
  const categories = data.categories || {};
  return Object.entries(categories)
    .filter(([, meta]) => meta.enabled !== false)
    .map(([key, meta]) => ({
      id: key,
      title: meta.label || key,
      description: meta.description || '',
      icon: meta.icon || defaultIcons[key] || '📋',
      link: `/services/${meta.slug || key}`
    }));
};
